import {
    buttonClassName,
    dropdownItemSlotClassNames,
    dropdownSlotClassNames,
    pxToRem,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const DropdownSortWrapper: StyleRule = () => ({
    ['& .' + dropdownSlotClassNames.triggerButton]: {
        outline: 'transparent',
    },
    [`& .${dropdownSlotClassNames.selectedItems}`]: {
        overflow: 'visible',
        [`& .${buttonClassName}`]: {
            overflow: 'visible',
        },
    },
    [`& .${dropdownSlotClassNames.itemsList}`]: {
        overflowX: 'hidden',
    },
    [`& > .${dropdownSlotClassNames.itemsList}`]: {
        maxHeight: pxToRem(340),
        [`& > .${dropdownSlotClassNames.item}`]: {
            padding: pxToRem(8),

            [`& .${dropdownItemSlotClassNames.header}`]: {
                letterSpacing: '0.02em',
            },
        },
    },
});
